/**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'Viimeisimmät sovelluksen sisäiset ilmoitukset',
    titleMeta: 'Näytetään viimeisimmät sovelluksen sisäiset ilmoitukset CamAPS FX',
    descriptionMeta: 'Tässä on teksti viimeisimmistä sovelluksen sisäisistä ilmoituksista, jotka koskevat sovelluspäivityksiä, turvallisuusilmoituksia ja käyttöopaspäivityksiä',
    keywords: 'sovelluksen' ,
    localeMeta: 'fi_fi',

    heading: 'Viimeisimmät sovelluksen sisäiset ilmoitukset',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'Android-sovelluksen päivitys (YpsoPump only) 28/10/2026',
    body_132:'Arvoisa CamAPS FX -käyttäjä, sovelluksen uusi versio 1.4(195) tulee saataville seuraavien päivien aikana. Valitse suosimasi päivitysaika poistamalla automaattinen päivitys käytöstä CamAPS FX:ssä Google Play Kaupassa. Jos sinulla on kysymyksiä, ota yhteyttä mylife-Diabetescarein asiakaspalveluun.',

    header_131:'',
    body_131:'',

    header_130:'Päivitys vaaditaan (vain YpsoPump) 20/10/2026',
    body_130:'Päivitys vaaditaan! Tämä CamAPS FX -versio saattaa kaatua ja käynnistyä uudelleen tavallista useammin. Päivitä uusimpaan versioon NYT Google Play Kaupan kautta. Sovellusversion 1.4(190) käyttö lopetetaan 20/11/2026. Tämän päivämäärän jälkeen “Auto Mode” ei ole enää käytettävissä ennen kuin sovellus on päivitetty. Insuliinin annostelu pumpun kautta jatkuu.',

    header_129:'',
    body_129:'',

    header_128:'Käyttöoppaan päivitys (vain YpsoPump) 15/10/2026',
    body_128:'Päivitetty versio käyttöoppaasta on nyt saatavilla. Voit avata sen CamAPS FX:n päävalikosta valitsemalla Ohje, kun olet päivittänyt uusimpaan sovellusversioon.',

    header_127:'iOS-sovelluspäivitys (YpsoPump only) 08/10/2026',
    body_127:'Hyvä CamAPS FX -käyttäjä, UUSI VERSIO sovelluksesta 1.4(196) tulee saataville seuraavien päivien aikana. POISTA CamAPS FX AUTOMAATTINEN PÄIVITYS käytöstä App Storessa valitaksesi mieluisan päivitysaikasi. Jos sinulla on kysyttävää, ota yhteyttä mylife-Diabetescarein asiakaspalveluun.',

    header_126:'Android-sovelluksen päivitys (YpsoPump only) 02/10/2026',
    body_126:'Arvoisa CamAPS FX -käyttäjä, sovelluksen uusi versio 1.4(194) tulee saataville seuraavien päivien aikana. Valitse suosimasi päivitysaika poistamalla automaattinen päivitys käytöstä CamAPS FX:ssä Google Play Kaupassa. Jos sinulla on kysymyksiä, ota yhteyttä mylife-Diabetescarein asiakaspalveluun.',

    header_125:'',
    body_125:'',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'',
    body_122:'',

    header_121:'Apple iOS 27 julkaisu 11/09/2026',
    body_121:'Apple julkaisee pian iOS 27:n. Varmistaaksesi CamAPS FX -sovelluksen keskeytymättömän käytön tarkista älypuhelimen ja käyttöjärjestelmän yhteensopivuus sensorin valmistajan verkkosivuilta ENNEN iPhonesi päivittämistä iOS 27:een. Automaattiset päivitykset voivat olla oletusarvoisesti PÄÄLLÄ puhelimen asetuksissa, joten harkitse niiden kytkemistä POIS PÄÄLTÄ.',

    header_120:'',
    body_120:'',

    header_119:'Käyttöoppaan päivitys (vain YpsoPump) 10/09/2026',
    body_119:'Päivitetty versio käyttöoppaasta on nyt saatavilla. Voit avata sen CamAPS FX:n päävalikosta valitsemalla Ohje, kun olet päivittänyt uusimpaan sovellusversioon.',

    header_118:'Android-sovelluksen päivitys (YpsoPump only) 07/09/2026',
    body_118:'Arvoisa CamAPS FX -käyttäjä, sovelluksen uusi versio 1.4(193) tulee saataville seuraavien päivien aikana. Valitse suosimasi päivitysaika poistamalla automaattinen päivitys käytöstä CamAPS FX:ssä Google Play Kaupassa. Jos sinulla on kysymyksiä, ota yhteyttä mylife-Diabetescarein asiakaspalveluun.',

    header_117:'',
    body_117:'',

    header_116:'',
    body_116:'',

    header_115:'',
    body_115:'',

    header_114:'',
    body_114:'',

    header_113:'',
    body_113:'',

    header_112:'',
    body_112:'',

    header_111:'Versiota 1.4(192) vanhempien Android-versioiden deaktivointi (Ypsopump only) 03/08/2026',
    body_111:'Hyvä CamAPS FX -käyttäjä, kyberturvallisuussyistä versiota 1.4(192) VANHEMMAT versiot POISTETAAN KÄYTÖSTÄ 31/08/2026. Varmista, että sovelluksesi on PÄIVITETTY versioon 1.4(192) ennen tätä päivämäärää. Jos sinulla on kysyttävää, ota yhteyttä mylife-Diabetescare-asiakaspalveluun.',

    header_110:'',
    body_110:'',
    body_110_link_text:'',
    body_110_end: '',
    body_110_link:'',

    header_109:'Android OS 17 julkaisu 24/06/2026',
    body_109:'Android julkaisee pian OS 17:n. Varmistaaksesi  CamAPS FX -sovelluksen keskeytymättömän käytön tarkista älypuhelimen ja käyttöjärjestelmän yhteensopivuus sensorin valmistajan verkkosivuilta ENNEN Android-laitteesi päivittämistä OS 17:ään. Automaattiset päivitykset voivat olla oletusarvoisesti PÄÄLLÄ puhelimen asetuksissa, joten kytke ne POIS PÄÄLTÄ.',

    header_108:'Dexcom G7 on saatavilla (vain Ypsopump) 23/06/2026',
    body_108:'Dexcom G7 CGM -järjestelmän integraatio on nyt saatavilla! Dexcom G6 -järjestelmästä siirtyvät käyttäjät löytävät verkkosivustoltamme vaihto-oppaan, vianmääritysohjeita sekä yleiskatsauksen yhteensopivista CGM-järjestelmistä: www.mylife-diabetescare.com.',

    header_107:'',
    body_107:'',

    header_106:'Käyttöoppaan päivitys (vain YpsoPump) 22/06/2026',
    body_106:'Päivitetty versio käyttöoppaasta on nyt saatavilla. Voit avata sen CamAPS FX:n päävalikosta valitsemalla Ohje.',

    header_105:'',
    body_105:'',

    header_104:'',
    body_104:'',

    header_103:'Android-sovelluksen päivitys (YpsoPump only) 12/06/2026',
    body_103:'Arvoisa mylife CamAPS FX -käyttäjä, sovelluksen uusi versio 1.4(192) tulee saataville seuraavien päivien aikana. Valitse suosimasi päivitysaika poistamalla automaattinen päivitys käytöstä CamAPS FX:ssä Google Play Kaupassa. Jos sinulla on kysymyksiä, ota yhteyttä mylife-Diabetescarein asiakaspalveluun.',

    header_102:'',
    body_102:'',

    header_101:'',
    body_101:'',

    header_100:'',
    body_100:'',

    header_99:'',
    body_99:'',

    header_98:'Vanhojen käyttöjärjestelmien tuen päättyminen 22/05/2026',
    body_98:'Valmistellessamme seuraavaa sovelluspäivitystä huomioithan, että CamAPS FX toimii VAIN sensoreiden kanssa yhteensopivissa puhelimissa, joissa on OS 13 tai uudempi tai Apple iOS 18 tai uudempi. Tämän julkaisun jälkeen käyttäjät, joiden puhelimissa on ALLE OS 13 tai iOS 18, EIVÄT voi PÄIVITTÄÄ tai ASENTAA CamAPS FX -sovellusta UUDELLEEN.',

    header_97:'iOS-sovelluksen päivitys 22/05/2026',
    body_97:'Hyvä CamAPS FX -käyttäjä, uusi versio CamAPS FX:stä, 1.4(195), tulee saataville lähipäivinä. Voit valita päivitysajankohdan poistamalla AUTOMAATTISET PÄIVITYKSET käytöstä App Storessa. Käyttäjät, joiden versio on ALLE Apple iOS 18, EIVÄT voi PÄIVITTÄÄ CamAPS FX:ää tähän versioon. Päivitetty versio käyttöoppaasta on nyt saatavilla. Lisätietoja saat ottamalla yhteyttä mylife-Diabetescare asiakaspalveluun.',

    header_96:'',
    body_96:'',

    header_95:'',
    body_95:'',

    header_94:'',
    body_94:'',

    header_93:'iOS-versioiden alle 1.4(193) deaktivointi (vain Ypsopump) 22/04/2026',
    body_93:'Hyvä CamAPS FX -käyttäjä, kyberturvallisuussyistä VERSIOT, JOTKA OVAT ALLE 1.4(193), POISTETAAN KÄYTÖSTÄ 30. huhtikuuta. Varmista, että sovelluksesi on PÄIVITETTY versioon 1.4(193) ennen tätä päivämäärää. Jos sinulla on kysyttävää, ota yhteyttä mylife-Diabetescare-asiakaspalveluun.',

    header_92:'Vanhojen käyttöjärjestelmien asteittainen käytöstäpoisto 21/04/2026',
    body_92:'Kyberturvallisuussyistä mylife CamAPS FX on 30. kesäkuuta 2026 alkaen TUETTU VAIN anturiyhteensopivissa puhelimissa, joissa on seuraavat käyttöjärjestelmät: Android OS 13 tai uudempi ja Apple iOS 18 tai uudempi. Käyttäjät, joilla on käyttöjärjestelmä, joka on ALEMPI kuin Android OS 13 tai Apple iOS 18, EIVÄT voi PÄIVITTÄÄ tai ASENTAA UUDELLEEN mylife CamAPS FX -sovellusta tämän päivämäärän jälkeen.',

    header_91:'',
    body_91:'',
    body_91_link_text:'',
    body_91_end: '',
    body_91_link:'',

    header_90:'',
    body_90:'',

    header_89:'',
    body_89:'',

    header_88:'',
    body_88:'',

    header_87:'iOS-versioiden alle 1.4(193) deaktivointi (vain Ypsopump) 16/03/2026',
    body_87:'Hyvä CamAPS FX -käyttäjä, kyberturvallisuussyistä VERSIOT, JOTKA OVAT ALLE 1.4(193), POISTETAAN KÄYTÖSTÄ 31. maaliskuuta. Varmista, että sovelluksesi on PÄIVITETTY versioon 1.4(193) ennen tätä päivämäärää. Jos sinulla on kysyttävää, ota yhteyttä mylife-Diabetescare-asiakaspalveluun.',

    header_86:'',
    body_86:'',
    body_86_link_text:'',
    body_86_end: '',
    body_86_link:'',

    header_85:'',
    body_85:'',

    header_84:'',
    body_84:'',

    header_83:'',
    body_83:'',

    header_82:'Android-sovelluksen päivitys (vain Ypsopump) 02/02/2026',
    body_82:'Hyvä CamAPS FX -käyttäjä, sovelluksesta tulee saataville UUSI VERSIO lähipäivinä – 1.4(190). POISTA CamAPS FX:N AUTOMAATTISET PÄIVITYKSET käytöstä Google Play Kaupassa, jotta voit valita itsellesi sopivan päivitysajankohdan. Kyberturvallisuussyistä VERSIOT, JOTKA OVAT ALLE 1.4(190), POISTETAAN KÄYTÖSTÄ 31. maaliskuuta. Jos sinulla on kysyttävää, ota yhteyttä mylife-Diabetescare-asiakaspalveluun.',

    header_81:'',
    body_81:'',

    header_80:'',
    body_80:'',

    header_79:'',
    body_79:'',

    header_78:'',
    body_78:'',

    header_77:'',
    body_77:'',

    header_76:'',
    body_76:'',

    header_75:'',
    body_75:'',

    header_74:'Viesti mylife-Diabetescareltä (vain YpsoPump) 09/12/2025',
    body_74:'Voit täyttää mylife YpsoPump -säiliösi kerran 7 päivän kuluessa ensimmäisestä täytöstä. Lue lisää mylife-diabetescare-verkkosivuston säiliösivulta.',

    header_73:'',
    body_73:'',
    body_73_link_text:'',
    body_73_end: '',
    body_73_link:'',

    header_72:'',
    body_72:'',
    body_72_link_text:'',
    body_72_end: '',
    body_72_link:'',

    header_71:'',
    body_71:'',
    body_71_link_text:'',
    body_71_end: '',
    body_71_link:'',

    header_70:'Tärkeää turvallisuustietoa FreeStyle Libre 3 -järjestelmäanturistasi 25/11/2025',
    body_70:'Abbott on havainnut, että jotkin FreeStyle Libre 3- ja FreeStyle Libre 3 Plus -anturit voivat näyttää virheellisen matalia glukoosiarvoja. Siirry osoitteeseen',
    body_70_link_text:'www.FreeStyleCheck.com',
    body_70_end: ' tarkistaaksesi, koskeeko tämä mahdollisesti nykyistä tai käyttämätöntä sensoriasi. Jos sensorin lukemat eivät vastaa oireitasi tai odotuksiasi, poista Auto-tila käytöstä ja käytä verensokerimittaria hoitopäätösten tekemiseen. Jos sinulla on kysyttävää tai haluat ilmoittaa ongelmista FreeStyle Libre 3 -järjestelmäsensorisi kanssa, ota yhteyttä Abbottin asiakaspalveluun numeroon 0 800 555 500. Nykyisen anturin sarjanumero löytyy sovelluksen valikosta kohdasta Anturi.',
    body_70_link:'https://www.FreeStyleCheck.com',
	
    header_69:'iOS-sovelluspäivitys (vain YpsoPump) 25/11/2025',
    body_69:'Hyvä mylife CamAPS FX -käyttäjä, UUSI VERSIO sovelluksesta tulee saataville seuraavien päivien aikana. DEAKTIVOI CamAPS FX:N AUTOMAATTISET PÄIVITYKSET App Storessa valitaksesi haluamasi päivitysaikajanan. Nykyinen versiosi LOPETETAAN 9. joulukuuta 2025. Jos sinulla on kysymyksiä, ota yhteyttä Ypsomedin asiakaspalveluun.',
	
    header_68:'',
    body_68:'',
	
    header_67:'',
    body_67:'',

    header_66:'',
    body_66:'',
    body_66_link_text:'',
    body_66_end: '',
    body_66_link:'',

    header_65:'',
    body_65:'',
    body_65_link_text:'',
    body_65_end: '',
    body_65_link:'',

    header_64:'',
    body_64:'',
    body_64_link_text:'',
    body_64_end: '',
    body_64_link:'',

    header_63:'',
    body_63:'',
    body_63_link_text:'',
    body_63_end: '',
    body_63_link:'',

    header_62:'KENTTÄTURVALLISUUSILMOITUS 28/10/2025',
    body_62:'Lue tärkeä neuvoa-antava huomautus',
    body_62_link_text:'N-0125',
    body_62_end: '. Siirry sovellusvalikkoon -> Turvallisuusilmoitukset.',
    body_62_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+Mylife+Users+FI+final.pdf',

    header_61:'iOS-sovelluspäivitys (vain YpsoPump) 02/10/2025',
    body_61:'Parhaan sovellussuorituskyvyn saavuttamiseksi, päivitä mylife CamAPS FX uusimpaan versioon (1.4(192)) Apple App Storesta.',

    header_60:'',
    body_60:'',

    header_59:'iOS-sovelluspäivitys (vain YpsoPump) 22/09/2025',
    body_59:'Hyvä mylife CamAPS FX -käyttäjä, UUSI VERSIO sovelluksesta tulee saataville seuraavien päivien aikana. POISTA CamAPS FX AUTOMAATTINEN PÄIVITYS käytöstä App Storessa valitaksesi mieluisan päivitysaikasi. Uusi käyttäjän oppaan versio tulee saataville. Jos sinulla on kysyttävää, ota yhteyttä YpsoMediin asiakaspalveluun.',

    header_58:'iOS 26 julkaisu (vain YpsoPump) 13/09/2025',
    body_58:'Apple julkaisee pian iOS 26:n. Jotta mylife CamAPS FX -sovelluksen käyttö olisi katkeamatonta, tarkista anturin valmistajan verkkosivuilta älypuhelimen ja käyttöjärjestelmän yhteensopivuus ennen kuin päivität iPhonesi iOS 26:een. Huom: Automaattiset päivitykset saattavat olla päällä puhelimesi asetuksissa oletuksena, muista kytkeä nämä pois.',

    header_57:'Android-sovelluksen päivitys (vain YpsoPump) 26/08/2025',
    body_57:'Arvoisa mylife CamAPS FX -käyttäjä, sovelluksen uusi versio tulee saataville seuraavien 2–3 päivän aikana. Valitse suosimasi päivitysaika poistamalla automaattinen päivitys käytöstä CamAPS FX:ssä Google Play Kaupassa. Uusi käyttäjän oppaan versio tulee saataville. Jos sinulla on kysymyksiä, ota yhteyttä Ypsomedin asiakaspalveluun.',

    header_56:'',
    body_56:'',

    header_55:'',
    body_55:'',

    header_54:'',
    body_54:'',

    header_53:'',
    body_53:'',
	
    header_52:'',
    body_52:'',
	
    header_51:'',
    body_51:'',

    header_50:'',
    body_50:'',

    header_49:'Vanhojen sovellusversioiden käytön lopetus 01/07/2025',
    body_49:'Nykyinen versio lakkaa toimimasta 31.07.2025. Päivitä sovelluksesi uusimpaan versioon, joka on saatavilla Google Playssa.',

    header_48:'OS 10 & 11 25/06/2025',
    body_48:'Kyberturvallisuussyistä mylife CamAPS FX ä tuetaan 1. elokuuta 2025 alkaen vain anturiyhteensopivilla puhelimilla, joissa on Android-käyttöjärjestelmät 12 ja uudemmat. Käyttöjärjestelmien käyttäjät, joiden versio on alle OS 12, eivät enää tämän päivämäärän jälkeen voi päivittää tai asentaa uudelleen mylife CamAPS FX ä.',

    header_47:'',
    body_47:'',

    header_46:'iOS-päivitys 09/06/2025',
    body_46:'Uusi sovellusversio on saatavilla lähipäivinä. Poista sovelluksen automaattiset päivitykset käytöstä ja valitse haluamasi päivitysaika. Jos sinulla on kysyttävää, ota yhteyttä Ypsomedin asiakaspalveluun.',

    header_45:'Android OS 16 09/06/2025',
    body_45:'Taataksesi katkeamattoman käytön mylife CamAPS FX -sovellukselle, tarkista valmistajan anturin verkkosivusto varmistaaksesi yhteensopivuuden ennen päivittämistä Android OS 16:ään. Huomio: Automaattiset päivitykset saattavat olla oletusarvoisesti päällä puhelimesi asetuksissa.',


    header_44:'iOS-julkaisu (vain YpsoPump) 20/05/2025',
    body_44:'mylife CamAPS FX -sovellus on nyt saatavana myös iPhone-puhelimille! Jos harkitset siirtymistä iOS-käyttöjärjestelmään, käy kohdassa ”Tärkeää tietoa iOS-käyttäjille” osoitteessa www.mylife-diabetescare.com/fi-FI/mylife-loop.html. Käyttöoppaasta on saatavilla päivitetty versio.',

    header_43:'',
    body_43:'',

    header_42:'',
    body_42:'',
	
    header_41:'',
    body_41:'',
 
    header_40:'Uusi päivitys (18/03/2025)',
    body_40:'Arvoisa mylife CamAPS FX -käyttäjä, Uusi sovellusversio on valmis seuraavan 48 tunnin aikana. Valitse haluamasi päivitysaika poistamalla automaattinen päivitys CamAPS FX:lle Google Play -kaupassa. Jos sinulla on kysyttävää, ota yhteyttä Ypsomedin asiakaspalveluun.',

    header_39:'',
    body_39:'',

    header_38:'',
    body_38:'',

    header_37:'Vanhan sovellusversion lopettaminen (vain Ypsopump)',
    body_37:'Nykyinen versio lakkaa toimimasta 7.02.2025. Päivitä sovelluksesi uusimpaan versioon, joka on saatavilla Google Playssa.',

    header_36:'Sovelluksen päivitys 06/01/2025',
    body_36:'Arvoisa mylife CamAPS FX -käyttäjä, Uusi sovellusversio on valmis seuraavan 48 tunnin aikana. Valitse haluamasi päivitysaika poistamalla automaattinen päivitys CamAPS FX:lle Google Play -kaupassa. Jos sinulla on kysyttävää, ota yhteyttä Ypsomedin asiakaspalveluun.',
	
	header_35:'OS 8 & 9 29/12/2024',
    body_35:'Kyberturvallisuussyistä mylife CamAPS FX ä tuetaan 1. tammikuuta 2025 alkaen vain anturiyhteensopivilla puhelimilla, joissa on Android-käyttöjärjestelmät 10 ja uudemmat. Käyttöjärjestelmien käyttäjät, joiden versio on alle OS 10, eivät enää tämän päivämäärän jälkeen voi päivittää tai asentaa uudelleen mylife CamAPS FX ä. Muistutus, järjestelmä ei ole vielä OS15-yhteensopiva',
	
	header_34:'',
    body_34:'',
	
	header_33:'Ilmoitus suunnitellusta huollosta 05/12/2024',
    body_33:'CamAPS FX -palvelun pilvipalvelimen suunnitellun huollon vuoksi Companion-toiminto ei ole käytettävissä 7. joulukuuta klo 10:00 GMT alkaen noin kolmen tunnin ajan. Pahoittelemme mahdollisia haittoja, joita tämä saattaa aiheuttaa.',
	
	header_32:'Käyttöoppaan päivitys 28/11/2024',
    body_32:'Käyttöoppaasta on saatavilla päivitetty versio.',
	
	header_31:'Sovelluksen päivitys 17/11/2024',
    body_31:'Arvoisa mylife CamAPS FX -käyttäjä, Uusi sovellusversio on valmis seuraavan 48 tunnin aikana. Valitse haluamasi päivitysaika poistamalla automaattinen päivitys CamAPS FX:lle Google Play -kaupassa. Jos sinulla on kysyttävää, ota yhteyttä Ypsomedin asiakaspalveluun.',
	
	header_30:'OS 8 & 9 11/10/2024',
    body_30:'Kyberturvallisuussyistä mylife CamAPS FX ä tuetaan 1. tammikuuta 2025 alkaen vain anturiyhteensopivilla puhelimilla, joissa on Android-käyttöjärjestelmät 10 ja uudemmat. Käyttöjärjestelmien käyttäjät, joiden versio on alle OS 10, eivät enää tämän päivämäärän jälkeen voi päivittää tai asentaa uudelleen mylife CamAPS FX ä.',
	
	header_29:'Sovelluksen päivitys 09/10/2024',
    body_29:'Arvoisa mylife CamAPS FX -käyttäjä, Uusi sovellusversio on valmis seuraavan 48 tunnin aikana. Valitse haluamasi päivitysaika poistamalla automaattinen päivitys CamAPS FX:lle Google Play -kaupassa. Jos sinulla on kysyttävää, ota yhteyttä Ypsomedin asiakaspalveluun.',
	
	header_28:'OS 8 & 9 08/07/2024',
    body_28:'Kyberturvallisuussyistä mylife CamAPS FX ä tuetaan 1. tammikuuta 2025 alkaen vain anturiyhteensopivilla puhelimilla, joissa on Android-käyttöjärjestelmät 10 ja uudemmat. Käyttöjärjestelmien käyttäjät, joiden versio on alle OS 10, eivät enää tämän päivämäärän jälkeen voi päivittää tai asentaa uudelleen mylife CamAPS FX ä.',
	
	header_27:'',
    body_27:'',
	
	header_26:'Käyttöoppaan päivitys 11/05/2024',
    body_26:'Käyttöoppaasta on saatavilla päivitetty versio.',
	
	header_25:'',
    body_25:'',
	
	header_24:'',
    body_24:'',
	
	header_23:'Sovelluksen päivitys',
    body_23:'Arvoisa mylife CamAPS FX -käyttäjä, Uusi sovellusversio on valmis seuraavan 24 tunnin aikana. Valitse haluamasi päivitysaika poistamalla automaattinen päivitys CamAPS FX:lle Google Play -kaupassa. Jos sinulla on kysyttävää, ota yhteyttä Ypsomedin asiakaspalveluun.',
	
	header_22:'Käyttöoppaan päivitys 21/04/2024',
    body_22:'Käyttöoppaasta on saatavilla päivitetty versio.',
	
	header_21:'',
    body_21:'',
	
	header_20:'',
    body_20:'',
	
	header_19:'',
    body_19:'',

    header_18:'',
    body_18:'',

    header_17:'',
    body_17:'',

	header_16:'Käyttöoppaan päivitys 04/03/2024',
    body_16:'Käyttöoppaasta on saatavilla päivitetty versio.',

	header_15:'Käyttöoppaan päivitys 04/01/2024',
    body_15:'Käyttöoppaasta on saatavilla päivitetty versio.',
	
	header_14:'Android OS 14. 22/11/2023',
    body_14:'Muistutus: Taataksesi katkeamattoman käytön mylife CamAPS FX -sovellukselle, tarkista valmistajan anturin verkkosivusto varmistaaksesi yhteensopivuuden ennen päivittämistä Android OS 14:ään. Huomio: Automaattiset päivitykset saattavat olla oletusarvoisesti päällä puhelimesi asetuksissa.OS 14:ään.',
	
	header_13:'KENTTÄTURVALLISUUSILMOITUS 14/11/2023',
    body_13:'KENTTÄTURVALLISUUSILMOITUS ',
    body_13_link_text:'Lue tärkeä neuvoa-antava huomautus',
    body_13_end: '. Siirry sovellusvalikkoon -> Turvallisuusilmoitukset.',
    body_13_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET5604+Mylife+Users+final+-+FI.pdf',

	header_12:'Käyttöoppaan päivitys 10/11/2023',
    body_12:'Käyttöoppaasta on saatavilla päivitetty versio.',
	
	header_11:'Android OS 14. 12/09/2023',
    body_11:'Taataksesi katkeamattoman käytön mylife CamAPS FX -sovellukselle, tarkista valmistajan anturin verkkosivusto varmistaaksesi yhteensopivuuden ennen päivittämistä Android OS 14:ään. Huomio: Automaattiset päivitykset saattavat olla oletusarvoisesti päällä puhelimesi asetuksissa.Varmista, että käytät mylife CamAPS FX -sovelluksen versiota 1.4(173) ennen päivitystä Android OS 14:ään.',
	
	header_10:'KENTTÄTURVALLISUUSILMOITUS 15/08/2023',
    body_10:'KENTTÄTURVALLISUUSILMOITUS Lue tärkeä neuvoa-antava huomautus. Siirry sovellusvalikkoon -> Turvallisuusilmoitukset.',
	
	header_9:'Käyttöoppaan päivitys 27/07/2023',
    body_9:'Käyttöoppaasta on saatavilla päivitetty versio.',
	
	header_8:'Glooko-yhteensopivuus 21/07/2023',
    body_8:'Kuten aiemmin ilmoitettiin, diasend lopetetaan 28. heinäkuuta. Jos haluat jatkaa datan jakamista diabetestiimisi kanssa, päivitä diasend-tilisi Glookoon tai luo uusi Glooko-tili. Päivitä uusimpaan mylife CamAPS FX -versioon, syötä uusi Glooko-käyttäjätunnus ja salasana jakovalikossa ja käynnistä puhelimesi uudelleen. Diasend pysyy käytettävissä historiatietojen tarkasteluun loppuvuoden ajan.',
	
	header_7:'Samsung A-sarjan 14/07/2023',
    body_7:'Samsung A-sarjan mallien käyttäjät (esim. A53, A33) ovat saattaneet kokea signaalin menetyksen CGM-anturilleen Samsungin uusimman One UI 5.1 -päivityksen jälkeen. Samsung on tunnistanut ongelman ja kehittää parhaillaan ratkaisua. Samsung aikoo julkaista One UI -päivityksen 24. heinäkuuta (riippuen alueestasi), joka ratkaisee signaalin menetyksen ongelman. On suositeltavaa asentaa päivitys heti kun se tulee saataville. Jos et ole vielä päivittänyt One UI 5.1:een, suosittelemme odottamaan seuraavaa Samsung One UI-päivitystä.',

    header_6:'Glooko-yhteensopivuus (Vain Ypsopump) 14/06/2023',
    body_6:'mylife CamAPS FX on yhteensopiva Glookon kanssa. Päivitä mylife CamAPS FX -sovelluksesi versioon 1.4(172). Jos jaat tietoja klinikan kanssa, sinulle ilmoitetaan olemassa olevalla diasend-tililläsi, kun klinikka päivittää Glookoon. Kun päivitys on valmis, syötä uusi Glooko-käyttäjätunnuksesi ja salasanasi jakovalikkoon ja käynnistä älypuhelimesi uudelleen. Päivitä Glookoon ennen 28. heinäkuuta 2023. Diasend on käytettävissä historiatietojen tarkastelemiseen loppuvuoden ajan.',

    header_5:'',
    body_5:'',

    header_4:'Käyttöoppaan päivitys 27/05/2023',
    body_4:'Käyttöoppaasta on saatavilla päivitetty versio.',

    header_3:'SMS-ilmoitukset (Vain Ypsopump) 11/05/2023',
    body_3:'Seuraavan päivityksen 1.4(171) myötä toukokuun puolivälissä voit aktivoida jopa 5 SMS-seuraajaa, JA käyttää samanaikaisesti Kumppani-tilaa. Kumppani-tilan käyttäjällä tulee olla internetyhteys datan jakamista varten. Käyttäjän puhelimessa tulee olla myös SIM-kortti, jotta hän voi lähettää tekstiviestejä puhelimestaan. Jos käytät jotain näistä vaihtoehdoista, suosittelemme tarkistamaan matkapuhelinoperaattorisi liittymäsopimuksen tekstiviestien ja/datan osalta.',

    header_2:'Cybersecurity-päivitys (Vain Ypsopump) 11/05/2023',
    body_2:'mylife CamAPS FX -sovelluksen turvallisuus on erittäin tärkeää. Cybersecurity-päivitys, joka tulee Google Play Storesta, otetaan käyttöön toukokuun puolivälissä. Voit testata puhelimesi etukäteen menemällä ohjevalikkoon ja tarkistamalla.',

    header_1:'',
    body_1:'',
};
